/** Generated by scripts/generate-build-version.mjs — do not edit manually. */
export const BUILD_VERSION = "4665bd5-11052";
